<template>
  <div
    id="app"
    class="d-flex flex-column app minh-100"
  >

    <router-view class="d-flex flex-column minh-100"></router-view>

  </div>
</template>

<style scoped>
</style>

<script>
export default {
  name: "App",
  metaInfo() {
    return {
      title: "Happy Menu | The Most Beautiful QR Code Menus in the World",
      titleTemplate: null,
      meta: [
        {
          name: "description",
          vmid: "description",
          content:
            "Happy Menu is your complete solution for a beautiful QR code menu that can be updated in real-time. Easily create one for your restaurant, bar or cafe today!",
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content: "Happy Menu | The Most Beautiful QR Code Menus in the World",
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content:
            "Happy Menu is your complete solution for a beautiful QR code menu that can be updated in real-time. Easily create one for your restaurant, bar or cafe today!",
        },
        {
          name: "og:image",
          vmid: "ogImage",
          content: "",
        },
        {
          name: "og:site_name",
          content: "Happy Menu",
        },
        {
          name: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index,follow",
        },
      ],
    };
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  components: {},
  props: [],
  mixins: [],
  computed: {},
};
</script>
